var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5935 0.383993C11.8431 0.629937 11.9834 0.963464 11.9834 1.31123C11.9834 1.659 11.8431 1.99252 11.5935 2.23847L3.21407 10.4918L11.5935 18.7451C11.7207 18.8661 11.8221 19.0108 11.8919 19.1708C11.9617 19.3309 11.9984 19.503 11.9999 19.6771C12.0015 19.8512 11.9678 20.0239 11.9008 20.1851C11.8339 20.3463 11.735 20.4927 11.61 20.6159C11.485 20.739 11.3363 20.8364 11.1727 20.9023C11.009 20.9683 10.8337 21.0015 10.6569 21C10.4801 20.9984 10.3054 20.9623 10.1429 20.8935C9.98045 20.8248 9.83352 20.7249 9.71069 20.5996L0.389859 11.419C0.140232 11.1731 4.79862e-07 10.8396 4.95063e-07 10.4918C5.10264e-07 10.144 0.140232 9.81051 0.389859 9.56456L9.71069 0.383993C9.96039 0.138122 10.299 -7.43525e-08 10.6521 -5.8919e-08C11.0052 -4.34854e-08 11.3438 0.138122 11.5935 0.383993Z",
    fill: "#68717A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.fc710487f7da9509545368389fdcdde4.svg";
export { ForwardRef as ReactComponent };